import React from 'react';
import { isHauptadmin } from '../../lib/globalData';
import dataProvider from '../../lib/dataProvider';
import { useRecordContext, useListContext, useTranslate, List, Datagrid, 
  TextInput, Filter, SelectInput } from 'react-admin';
import NoPagination from '../../lib/NoPagination';
import Ansi from "../../lib/ansi2react";
import Button from '@mui/material/Button';

const NewlineField = ({val}) => {
  if(!val) return null
  return (
    <>
      {val.split('\n').map(v=> <div>{v}</div>)}
    </>
  )
}

const InfoField = () => {
  const tr = useTranslate()
  const rec = useRecordContext()
  if (!rec) return null
  return (
    <div style={{maxWidth: '50em'}}>
      <div style={{fontWeight: 'bold'}}>{rec.id}</div>
      <div>{tr('bw.set.tkonfigspez.info.'+rec.id)}</div>
      <div>ok: {rec.ok}; cnt: {rec.cnt}</div>
      <NewlineField val={rec.info} />
    </div>
  )
}

const StatusField = () => {
  const tr = useTranslate()
  const rec = useRecordContext()
  const {refetch} = useListContext();
  
  const handleSetup = () => {
    dataProvider.update('setTkonfigspez', { id: rec.id, data: {configure: true} })
      .then(res  => {
        refetch()
        if(res?.data?.msg)alert(res.data.msg)
      })
  }

  if (!rec) return null
  if(rec.action) return <div>AVAILABLE</div>
  return (
    <Button variant="contained" onClick={handleSetup}>{tr('bw.set.tkonfigspez.configure')}</Button>
  )
}

const HelpField = () => {
  const tr = useTranslate()
  const rec = useRecordContext()
  if (!rec) return null
  return (
    <Ansi>{tr('bw.set.tkonfigspez.help.'+rec.id)}</Ansi>
  )
}

const ListForm = (props) => {
  const rowstyle = () => {return {verticalAlign: 'top'}}
  return (
    <List sort={{ field: 'pos', order: 'ASC' }} filters={<ListFilter />}
      exporter={isHauptadmin() && props.exporter} pagination={<NoPagination />} perPage={1000} >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={false} rowStyle={rowstyle}>
        <InfoField label="Info" source="id" />
        <StatusField label="Status" source="action" />
        <HelpField label="Help" />
      </Datagrid>
    </List>
  )
}

const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput source="q" label="Search" alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />
    <SelectInput source="action" choices={[{id: true, name: 'Available'},{id: false, name: 'Not available'}]}alwaysOn />
  </Filter>
);

const SetTkonfigspez =  {
  list: ({ classes, ...props }) => (
    <ListForm {...props} classes={classes} />
  )
}   
export default SetTkonfigspez;